
/* ==========================================================================
   KINOVA — Kino / Serial tafsilotlari sahifasi mantiqi
   (movie-details.html va series-details.html ikkalasida ham ishlatiladi;
   body[data-detail-type] orqali farqlanadi)
   ========================================================================== */

(function () {
  var D = window.KDATA, C = window.KC;
  var isSeries = document.body.getAttribute('data-detail-type') === 'series';

  /* ⚠️ TUZATISH (14-bosqich, JIDDIY XATO):
     ilgari slug FAQAT `?slug=` query-parametridan o'qilardi:

         KUtil.qs('slug', isSeries ? 'tungi-shahar' : 'movie-example')

     Bu prototip davridan qolgan (`movie-details.html?slug=X`). 14-bosqichda
     havolalar TOZA marshrutlarga o'tkazildi (`/kino/{slug}`), demak
     `?slug=` endi URL'da YO'Q — natijada har doim STANDART qiymat
     ishlatilib, QAYSI kinoni bosgandan qat'i nazar bir xil demo kino
     ("movie-example" = "Yulduzlar Sayyorasi") ko'rsatilardi. Sahifa
     serverda TO'G'RI render qilinardi, lekin bu JS uni darhol NOTO'G'RI
     kino bilan almashtirib qo'yardi (poster/rasm ham shu sababli
     yo'qolardi — demo kinoda rasm fayli yo'q).

     Endi slug UCH manbadan, ISHONCHLILIK tartibida olinadi:
       1) `#detailHero[data-fav-slug]` — SERVER bergan qiymat (eng ishonchli,
          Blade `$slug` bilan to'ldiradi);
       2) URL yo'li — `/kino/{slug}` yoki `/serial/{slug}`;
       3) `?slug=` — eski havolalar bilan orqaga moslik uchun.
     Hech biri bo'lmasa — avvalgi xatti-harakat (ro'yxatdagi birinchi). */
  function resolveSlug() {
    var hero = document.getElementById('detailHero');
    var fromServer = hero && hero.getAttribute('data-fav-slug');
    if (fromServer) return fromServer;

    var m = window.location.pathname.match(/\/(?:kino|serial)\/([^/?#]+)/);
    if (m && m[1]) return decodeURIComponent(m[1]);

    return KUtil.qs('slug', '');
  }

  var slug = resolveSlug();
  var item = slug ? (isSeries ? D.getSeriesBySlug(slug) : D.getMovieBySlug(slug)) : null;

  /* Katalogda topilmasa (masalan kino ADMIN PANELDA hozir qo'shilgan va
     `window.KDATA` keshi hali yangilanmagan) — SERVER render qilgan
     HTML'ni TEGMASDAN qoldiramiz. Ilgari bu holatda ro'yxatdagi birinchi
     kino ko'rsatilardi, ya'ni foydalanuvchi BOSHQA kinoni ko'rardi.
     Endi noto'g'ri kino ko'rsatilmaydi: sahifa serverdagi to'g'ri
     natija bilan qoladi. */
  /* ⚠️ Kino keshlangan katalogda bo'lmasa sahifa SERVER render qilgan
     holida qoladi — lekin sevimlilar tugmasi baribir ishlashi kerak,
     shuning uchun shu yerda ulanadi va chiqib ketiladi. */
  if (!item) { wireFavorites(); return; }

  document.title = item.title + ' — KINOVA';

  function metaHTML() {
    var parts = [
      '<span class="badge badge-lg badge--rating">' + Icon.starFilled(14) + '<b>' + item.rating.toFixed(1) + '</b></span>',
      '<span>' + item.year + '</span>',
      '<span>' + item.country + '</span>'
    ];
    if (!isSeries) parts.push('<span>' + C.formatDuration(item.duration) + '</span>');
    else parts.push('<span>' + (item.seasons ? item.seasons.length : item.seasonsCount) + ' fasl</span>');
    parts.push('<span class="badge badge-lg badge--quality">' + item.quality + '</span>');
    return parts.join('<span class="dot-sep">&middot;</span>');
  }

  /* ⚠️ TUZATISH (14-bosqich): ilgari serial havolasi QATTIQ KODLANGAN edi
     (`?season=1&episode=1`) — "har bir serialda 1-fasl 1-qism bor" degan
     asossiz taxmin. Demo ma'lumotda faqat bitta serial to'liq qismlarga
     ega, shuning uchun qolganlarida "Tomosha qilish" QO'POL 404 berardi.
     Endi havola HAQIQIY birinchi qismdan quriladi; qismlar ro'yxati
     ma'lum bo'lmasa parametrsiz havola beriladi va SERVER birinchi
     qismni o'zi tanlaydi (PlayerController). Bu mantiq
     `resources/views/components/detail-hero.blade.php` bilan AYNAN bir
     xil — ikkalasi bir xil natija berishi shart (SSR ↔ JS). */
  function firstEpisodeOf(it) {
    var seasons = it.seasons || [];
    for (var i = 0; i < seasons.length; i++) {
      var eps = seasons[i].episodes || [];
      if (eps.length) return { season: seasons[i].number, episode: eps[0].number };
    }

    return null;
  }

  var firstEpisode = isSeries ? firstEpisodeOf(item) : null;
  var watchHref = '/tomosha/' + item.slug;
  if (firstEpisode) watchHref += '?season=' + firstEpisode.season + '&episode=' + firstEpisode.episode;

  // Qism umuman bo'lmasa tugma ko'rsatilmaydi (o'lik tugma bo'lmasin) —
  // detail-hero.blade.php'dagi `$showWatch` bilan bir xil shart.
  var showWatch = !isSeries || firstEpisode !== null || (item.episodeCount || 0) > 0;

  var heroRoot = document.getElementById('detailHero');
  heroRoot.innerHTML = '' +
    '<div class="detail-hero__backdrop">' + C.backdropArt(item, { eager: true }) + '</div>' +
    '<div class="detail-hero__scrim"></div>' +
    '<div class="container detail-hero__inner">' +
    '<div class="detail-hero__poster">' + C.posterArt(item) + '</div>' +
    '<div class="detail-hero__info">' +
    '<h1>' + C.esc(item.title) + '</h1>' +
    '<p class="detail-hero__original">' + C.esc(item.originalTitle || '') + '</p>' +
    '<div class="detail-hero__meta">' + metaHTML() + '</div>' +
    '<div class="detail-hero__genres">' + C.genreChips(item.genres) + '</div>' +
    '<p class="detail-hero__desc">' + C.esc(item.description) + '</p>' +
    '<div class="detail-hero__persons">' +
    (item.director ? '<div class="detail-person-row"><span class="detail-person-row__label">Rejissyor</span><span class="detail-person-row__names">' + C.esc(item.director) + '</span></div>' : '') +
    (item.actors ? '<div class="detail-person-row"><span class="detail-person-row__label">Aktyorlar</span><span class="detail-person-row__names">' + C.esc(item.actors.join(', ')) + '</span></div>' : '') +
    '</div>' +
    '<div class="detail-hero__actions">' +
    (showWatch ? '<a href="' + watchHref + '" class="btn btn--primary btn--lg">' + Icon.play(18) + ' Tomosha qilish</a>' : '') +
    '<button type="button" class="btn btn--outline btn--lg" id="favBtn">' + Icon.plus(18) + ' Sevimlilar</button>' +
    '<button type="button" class="icon-btn icon-btn--outline" id="shareBtn" aria-label="Ulashish">' + Icon.share(19) + '</button>' +
    '</div>' +
    '</div>' +
    '</div>';

  /* ---- Sevimlilar (Bosqich 8: haqiqiy fetch()/API — Bosqich 1'dan buyon
     FAQAT client-JS xotirasida demo edi, sahifa yangilansa yo'qolardi).
     Boshlang'ich holat `heroRoot`ning O'ZIDAGI (yuqorida — bu element
     `innerHTML` bilan ALMASHTIRILMAYDI, faqat ICHI to'ldiriladi, shuning
     uchun `data-fav-*` atributlari saqlanadi) `data-fav-*` atributlaridan
     o'qiladi — ContentController HAR SO'ROVDA yangidan hisoblaydi
     (keshlangan katalog/bootstrap'ga ATAYLAB qo'shilmagan, ContentController
     sarlavha izohiga qarang). ---- */
  /* 23-bosqich — JIM O'LIK TUGMA TUZATILDI.
     Bu blok ilgari `if (!item) return;` dan KEYIN turardi. Ya'ni kino
     keshlangan katalogda bo'lmasa (masalan hozirgina qo'shilgan — kesh
     10 daqiqa yashaydi) butun skript shu yerga yetib kelmasdi va
     "Sevimlilar" tugmasiga HECH QANDAY hodisa ulanmasdi: bosilardi,
     lekin hech narsa bo'lmasdi (xato ham, xabar ham yo'q).
     Endi sevimlilar kesh holatiga BOG'LIQ EMAS. */
  function wireFavorites() {
    var favBtn = document.getElementById('favBtn');
    if (!favBtn || !heroRoot) return;
    var favSlug = heroRoot.getAttribute('data-fav-slug');
    var favLoginUrl = heroRoot.getAttribute('data-login-url') || '/login';
    var isFav = heroRoot.getAttribute('data-fav-active') === '1';
    var favBusy = false;

    function paintFavBtn() {
      favBtn.classList.toggle('fav-active', isFav);
      favBtn.innerHTML = (isFav ? Icon.checkCircle(18) : Icon.plus(18)) + (isFav ? ' Sevimlilarda' : ' Sevimlilar');
    }
    paintFavBtn();

    favBtn.addEventListener('click', function () {
      /* Mehmon: sevimlilar FAQAT tizimga kirgan foydalanuvchi uchun
         (FavoriteController + routes/web.php'dagi `auth` guruhi) — shuning
         uchun bosilganda darhol kirish sahifasiga yo'naltiriladi, xato
         so'rov umuman yuborilmaydi. */
      if (!D.CURRENT_USER) { window.location.href = favLoginUrl; return; }
      if (favBusy || !favSlug || !window.KINOVA_CSRF_TOKEN) return;

      var wasFav = isFav;
      isFav = !isFav;
      favBusy = true;
      paintFavBtn();
      C.toast(isFav ? 'Sevimlilarga qo\'shildi' : 'Sevimlilardan olib tashlandi');

      fetch('/favorites/' + encodeURIComponent(favSlug), {
        method: wasFav ? 'DELETE' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': window.KINOVA_CSRF_TOKEN,
          Accept: 'application/json',
        },
      }).then(function (res) {
        if (!res.ok) throw new Error('fav-toggle-failed');
        return res.json();
      }).then(function (data) {
        isFav = !!data.is_favorited;
        paintFavBtn();
      }).catch(function () {
        /* Server holati noaniq qoldi — xavfsiz tomonga: oldingi holatga
           qaytariladi va foydalanuvchiga qayta urinish taklif qilinadi. */
        isFav = wasFav;
        paintFavBtn();
        C.toast('Xatolik yuz berdi, qaytadan urinib ko\'ring');
      }).finally(function () {
        favBusy = false;
      });
    });
  }

  wireFavorites();   // hero qayta chizilgandan KEYIN (tugma almashtiriladi)

  /* ---- Ulashish modali ---- */
  document.getElementById('shareBtn').addEventListener('click', function () { openShareModal(); });

  function openShareModal() {
    var old = document.getElementById('shareModal');
    if (old) old.remove();
    var overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    overlay.id = 'shareModal';
    overlay.innerHTML = '' +
      '<div class="modal">' +
      '<div class="modal__head"><h3>Ulashish</h3><button type="button" class="icon-btn" id="shareModalClose">' + Icon.close(18) + '</button></div>' +
      '<p class="text-secondary" style="margin-bottom:18px;font-size:14px;">"' + C.esc(item.title) + '" nomli kontentni do\'stlaringiz bilan ulashing.</p>' +
      '<div style="display:flex;gap:12px;margin-bottom:22px;">' +
      '<button type="button" class="icon-btn icon-btn--lg" aria-label="Telegram">' + Icon.telegram(22) + '</button>' +
      '<button type="button" class="icon-btn icon-btn--lg" aria-label="Facebook">' + Icon.facebook(22) + '</button>' +
      '<button type="button" class="icon-btn icon-btn--lg" aria-label="Instagram">' + Icon.instagram(22) + '</button>' +
      '</div>' +
      '<div class="field" style="margin-bottom:0;">' +
      '<label>Havola</label>' +
      '<div class="copy-row"><input type="text" readonly value="https://kinova.uz/' + (isSeries ? 'serial' : 'kino') + '/' + item.slug + '">' +
      '<button type="button" class="btn btn--sm btn--ghost" id="copyLinkBtn">Nusxalash</button></div>' +
      '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    function close() { overlay.classList.remove('is-open'); setTimeout(function () { overlay.remove(); }, 250); }
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.getElementById('shareModalClose').addEventListener('click', close);
    document.getElementById('copyLinkBtn').addEventListener('click', function () {
      C.toast('Havola nusxalandi');
      close();
    });
  }

  /* ---- O'xshash kontent ---- */
  var pool = isSeries ? D.SERIES : D.MOVIES;
  var similar = pool.filter(function (x) { return x.slug !== item.slug && x.genres.some(function (g) { return item.genres.indexOf(g) > -1; }); }).slice(0, 12);
  if (!similar.length) similar = pool.filter(function (x) { return x.slug !== item.slug; }).slice(0, 12);
  var simRoot = document.getElementById('detailSimilarRoot');
  if (simRoot) simRoot.innerHTML = C.movieRow('O\'xshash ' + (isSeries ? 'seriallar' : 'kinolar'), similar, {});

  /* ---- Serial: sezon selector + epizodlar ---- */
  if (isSeries && item.seasons && item.seasons.length) {
    (function renderSeasons() {
      var root = document.getElementById('seasonsRoot');
      if (!root) return;
      var activeSeason = item.seasons[0].number;

      function episodesHTML(seasonNum) {
        var season = item.seasons.filter(function (s) { return s.number === seasonNum; })[0];
        return '<div class="episode-list">' + season.episodes.map(function (ep) { return C.episodeCard(ep, item.slug); }).join('') + '</div>';
      }
      function tabsHTML() {
        return '<div class="tabs" id="seasonTabs">' + item.seasons.map(function (s) {
          return '<button type="button" class="tabs__btn' + (s.number === activeSeason ? ' is-active' : '') + '" data-season="' + s.number + '">Sezon ' + s.number + '</button>';
        }).join('') + '</div>';
      }
      function paint() {
        var activeEpisodes = item.seasons.filter(function (s) { return s.number === activeSeason; })[0].episodes;
        root.innerHTML = '' +
          '<div class="season-bar">' + tabsHTML() + '<span class="episode-count-label">' + activeEpisodes.length + ' qism</span></div>' +
          episodesHTML(activeSeason);
        root.querySelectorAll('.tabs__btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            activeSeason = parseInt(btn.getAttribute('data-season'), 10);
            paint();
            if (window.KRefreshReveal) window.KRefreshReveal();
          });
        });
      }
      paint();
    })();
  }

  if (window.KRefreshReveal) setTimeout(window.KRefreshReveal, 40);
})();

